import React,{useState,useEffect,useContext,useMemo,useRef} from "react";
import studylistContext from "../../context/studylist/StudylistContext";
import LoadingBar from "react-top-loading-bar";
import { CSSTransition, Transition } from "react-transition-group";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getExpandedRowModel,
  createRow,
  expandRows,
  RowSelection,
} from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery
} from "@tanstack/react-query";
import { t } from "i18next";
import { USERTYPES, ZERO_IMAGE_ALLOWED_MODALITIES } from "../../constants/Constants";
import MobileListComponent from "../../pages/StudyList/components/MobileListComponent";
import { Spinner, SpinnerSize } from "@fluentui/react";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import userContext from "../../context/users/UserContext";
import { getEnv } from "../../helpers/EnvHelper";
import { getPriors } from "../../service/StudyListService";

const MobileStudyListTable = (props) => {
  const [allowAddingRows, setAllowAddingRows] = useState(false);
  const tbodyRef = useRef(null);
    const {
        filterInputValues,
        showCount,
        setShowCount,
        refreshRequired,
        setRefreshRequired,
        storedRows,
        setStoredRows,
        studyListLoading,
        setStudyListLoading,
        studyListRef,
        dataQueryState,
        setDataQueryState,
        updateLockUnlockRows,
        setUpdateLockUnlockRows,
        setSearchResultLength,
        menuItemsForBatchAndInference,
        rowSelectionState,
        setRowSelectionState,
        setRowSelectedArray,
        rowSelectedArray,
        getCountOfAbleToDeleteStudies,
        handleBatchReInference,
        batchReinferenceAndDeleteArray,
        resetRowSelection,
        setResetRowSelection,
        handleBatchDelete,
        unreportedAllTabs,
        fetchData,
        fetchDataMobile,
        setFirstTimeLoading,
        filterApplied,
        allDataElement, setAllDataElement,
        searchResultLength,
        handleChangeSizeIndex,
        sortGlobal,
        paginationObj,
        setFilterApplied,
        showViewer
      } = useContext(studylistContext);

      const { setAlertSuccessModal, alertSuccessModal} = useContext(studyReportContext);
      const {contextSwitchUser, priviledgedFirmTechnician, showViewerTechnician} = useContext(userContext);

      const queryClient = useQueryClient();

      const [rowSelection, setRowSelection] = useState({});
      const defaultData = useMemo(() => [], []);
      const [expanded, setExpanded] = useState({});
      const id = props.id;
      const sortObj = props.sortObj;
      const pageObj = props.pageObj;
      const filterObj = props.filterObj;
      const pageIndexFromParent = paginationObj[props.id].pageIndex;
      const [nextPageIndex,setNextPageIndex] = useState(1);
      
      const [showPullRefreshLoader, setShowPullRefreshLoader] = useState(false);

      // Priors of each study, keyed by study id rather than row id: row ids are
      // indexes, so a refresh would otherwise hang one study's priors under another.
      const [priorStudies, setPriorStudies] = useState({});
      const [expandedPriors, setExpandedPriors] = useState({});
      const [priorsLoading, setPriorsLoading] = useState({});

      const [{ pageIndex, pageSize }, setPagination] = useState({
        pageIndex: props.pageObj.pageIndex,
        pageSize: props.pageObj.pageSize,
      });

      const pagination = useMemo(
        () => ({
          pageIndex,
          pageSize,
        }),
        [pageIndex, pageSize]
      );

      const fetchDataOptions = {
        pageIndex: pageIndexFromParent,
        showCount,
        pageSize,
        sortObj,
        id,
        filterObj: filterApplied,
        subTabId: props.subTabId || "",
        //refreshRequired
      };


      // const {
      //   data,
      //   status,
      //   error,
      //   fetchNextPage,
      //   isFetchingNextPage,
      //   isFetching,
      //   isFetched,
      //   hasNextPage
      // } = useInfiniteQuery({
      //   queryKey: [fetchDataOptions],
      //   queryFn: ({ pageParam }) => {
      //      if(newPageIndex != 0)
      //       return fetchDataMobile({ options: fetchDataOptions, pageParams: pageIndexFromParent, temp: pageParam })
          
      //   }, 
      //   initialPageParam: 0,
      //   getNextPageParam: (lastPage, allPages) => {
      //     console.log("--- Get Param calling---")
      //     // const nextPage =  allPages.length + 1 ;
      //     // return nextPage;
      //   },
      //   keepPreviousData: true,
      //   staleTime: Infinity,
      //   cacheTime: 15 * 60 * 1000,
      //   initialData: () => {
      //     return queryClient.getQueryData(['data']);
      //   },
      //   initialDataUpdatedAt: () =>
      //     queryClient.getQueryState(['data'])?.dataUpdatedAt,
      // });

      const dataQuery = useQuery({
        queryKey: ["data", fetchDataOptions],
        queryFn: () => fetchDataMobile(fetchDataOptions),
        keepPreviousData: true,
        staleTime: Infinity, // Set stale time to 5 minutes
        gcTime: 15 * 60 * 1000, // Set cache time to 5 minutes (renamed from cacheTime)
        initialData: () => {
          return queryClient.getQueryData(["data"]);
        },
        initialDataUpdatedAt: () =>
          queryClient.getQueryState(["data"])?.dataUpdatedAt,
      });

      // useEffect(() => {
      //  if(dataQuery != undefined){
      //   // const formattedData = data?.pages.reduce((acc, page) => [...acc, ...page], []);
      //   //  console.log("--- Fetch Data ----",data,data.pages);
      //   if (isFetched && dataQuery != undefined) {
      //     let dataArray = allDataElement;
      //     console.log("---Page Index---",props.pageObj.pageIndex);
      //     if(props.pageObj.pageIndex >= 1){
      //       dataArray = [...dataArray, ...data.pages[0].rows];
      //     }else{
      //       if (tbodyRef?.current) {
      //         // console.log("--- Tbody ---",tbodyRef?.current?.scrollTop);
      //         if(tbodyRef?.current?.scrollTop != null && tbodyRef?.current?.scrollTop != undefined){
      //           tbodyRef.current.scrollTop = 0;
      //         }
      //       }
      //      dataArray = data.pages[0].rows;
      //     }
      //     console.log("--- Setting Data ---",dataArray);
      //     setFirstTimeLoading(false);
      //     setAllDataElement(dataArray);
      //   }
      //  }
        
      // }, [isFetched,isFetching]);

      useEffect(()=>{

      },[props.id])

      useEffect(()=>{
        if( pageIndex > 0 && searchResultLength <= 0){
          // console.log("---- Use Effect Running ----",searchResultLength,props.pageIndex);
          let tempPaginationObj = {
            pageIndex : pagination.pageIndex - 1,
            pageSize : pagination.pageSize
          };
          
          setPagination(tempPaginationObj)
  
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.no-more-pages");
            return newItem;
          });
        }
    },[searchResultLength])

      // Infinite-scroll trigger is wired into the virtualizer below
      // (see `useEffect` watching the last visible virtual item).

      useEffect(() => {
        console.log("--DataQueryState--",dataQueryState);
      }, [dataQueryState]);

      // useEffect(() => {
      //   // console.log("DATA QUERY")
      //   // console.log(dataQuery)
      //   if (isFetched) {
      //     setFirstTimeLoading(false);
      //     let dataQuery = {data: data?.pages[0]}
      //     // setDataQueryState(dataQuery);
      //     // props.setDataQueryParent(dataQuery);
      //   }
      // }, [isFetched, isFetching]);


      useEffect(()=>{
        // console.log("--- Data ----",dataQueryState,data);
      },[dataQueryState])
      

      const mobileColumns = useMemo(
        () => [
          {
            id: "patientDetails",
            show: true,
            accessorFn: (row) => row.id,
            accessorKey: "patientDetails",
            cell: (info) => <MobileListComponent data={info} roles={props.roles} tabId = {props.id} subTabId={props.subTabId} />,
            header: () => (
              <span className="study-list-header-txt">{t("study-list.column.patient-details")}</span>
            ),
            footer: (props) => props.column.id,
          },
        ],
        [props.id, props.subTabId]
      );

      useEffect(() => {
        props.handleChangeSizeIndex(pageIndex, pageSize, props.paginationKey || props.id);
      }, [pageIndex, pageSize]);

      useEffect(() => {
        if (dataQuery != undefined && dataQuery != null && dataQuery.isFetched) {
          console.log("--- Tab change ---", dataQuery);
          setSearchResultLength(dataQuery?.data?.rows?.length);
          // props.setDataQueryParent(dataQuery);
          // if(pageIndexFromParent > 0){
          //   handleUpdateDataQuery();
          // }else{
          //   setDataQueryState(dataQuery);
          // }
        }
      }, [props.id]);

      useEffect(() => {
        if (dataQuery.isFetched) {
          setFirstTimeLoading(false);
          setShowPullRefreshLoader(false);
          // console.log("---Making False---",dataQuery,paginationObj[props.id]);
          setRefreshRequired(() => {
            const newItem = { ...refreshRequired };
            newItem[props.id].alreadyLoaded = true;
            return newItem;
          });
          props.setDataQueryParent(dataQuery);
          if(paginationObj[props.id].pageIndex > 0 && allowAddingRows){
            handleUpdateDataQuery();
          }else{
            setDataQueryState(dataQuery);
          }
          
          
        }
      }, [dataQuery.isFetched, dataQuery.isFetching]);

      useEffect(() => {
        if (dataQuery != undefined && dataQuery != null) {
          setSearchResultLength(dataQuery?.data?.rows?.length);
          props.setDataQueryParent(dataQuery);
          if (!(paginationObj[props.id].pageIndex > 0 && allowAddingRows)) {
            setDataQueryState(dataQuery);
          }
        }
      }, [sortGlobal]);

      useEffect(() => {
        // console.log("--- Refresh Required Data -----",refreshRequired);
        if (refreshRequired !== null && refreshRequired[props.id].alreadyLoaded == false) {
          dataQuery.refetch();
        }
      }, [refreshRequired]);
    
      useEffect(() => {
        if (refreshRequired[props.id].alreadyLoaded == false) {
          setTimeout(() => {
            dataQuery.refetch();
          }, 10);
        }
      }, [props.id]);

      const handleUpdateDataQuery = () => {
        dataQueryState.data.rows = dataQueryState?.data?.rows.concat(dataQuery?.data?.rows);
        console.log("--New Data--",dataQueryState);
        setDataQueryState(dataQueryState);
      }
    
      useEffect(() => {
        setPagination({ pageIndex: pageIndexFromParent, pageSize: pageSize });
      }, [pageIndexFromParent]);

     useEffect(()=>{
        setAllowAddingRows(false);
        handleChangeSizeIndex(0,pageSize,props.paginationKey || props.id);
        if(pageIndexFromParent != 0){
          setTimeout(() => {
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
          }, 200);
        }
     },[props.id])




      const table = useReactTable({
        data: dataQueryState?.data?.rows ?? defaultData,
        columns: mobileColumns,
        pageCount: dataQueryState?.data?.pageCount ?? -1,
        state: {
          pagination,
          rowSelection,
          expanded,
        },
        onPaginationChange: setPagination,
        onRowSelectionChange: setRowSelection,
        getCoreRowModel: getCoreRowModel(),
        // getExpandedRowModel: getExpandedRowModel,
        // getExpandedRowModel: (row) => fetchPriorsData(row),
        onExpandedChange: setExpanded,
        manualPagination: true,
        manualExpanding: true,
        meta: {
          priors: {
            isExpanded: (studyId) => !!expandedPriors[studyId],
            isLoading: (studyId) => !!priorsLoading[studyId],
            toggle: (row) => togglePriors(row),
          },
          // removeRowFromStudyList: (studyId) => {
          //   let newData = dataQueryState?.data?.rows.filter(
          //     (row) => row.id !== studyId
          //   );
          //   updateDataQueryState(newData);
          // },
          // updateTriageDetailFromStudyList: (studyId, maxAiEmergency) => {
          //   let newTriageDetails = dataQueryState?.data?.rows.map((row) =>{
          //     return row.id === studyId ? {...row, aiEmergencyMax:maxAiEmergency} : row;
          //   });
          //   updateDataQueryState(newTriageDetails);
          // },
        },
        // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
        debugTable: true,
      });

      const togglePriors = async (row) => {
        const studyId = row.original.id;
        if (priorsLoading[studyId]) return;
        if (expandedPriors[studyId]) {
          setExpandedPriors((prev) => ({ ...prev, [studyId]: false }));
          return;
        }
        if (!priorStudies[studyId]) {
          setPriorsLoading((prev) => ({ ...prev, [studyId]: true }));
          const response = await getPriors({ studyId });
          setPriorsLoading((prev) => ({ ...prev, [studyId]: false }));
          if (response?.status !== 200 || response?.data?.result !== "SUCCESS") {
            setAlertSuccessModal(() => {
              const newItem = { ...alertSuccessModal };
              newItem.show = true;
              newItem.heading = "Error";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = response?.data?.message || t("string-literals.error-msg");
              return newItem;
            });
            return;
          }
          const priors = response.data.data?.studies?.searchResults ?? [];
          setPriorStudies((prev) => ({ ...prev, [studyId]: priors }));
        }
        setExpandedPriors((prev) => ({ ...prev, [studyId]: true }));
      };

      const tableRows = table.getRowModel().rows;

      // The desktop table hangs priors under their study as depth-1 rows; here
      // they go into the same flat list the virtualizer renders, so each prior
      // gets a full card of its own.
      const displayRows = useMemo(
        () =>
          tableRows.flatMap((row) => {
            const priors = expandedPriors[row.original.id] && priorStudies[row.original.id];
            if (!priors) return [row];
            return [
              row,
              ...priors.map((prior, index) =>
                createRow(table, row.id + "." + index, prior, index, 1, [], row.id)
              ),
            ];
          }),
        [tableRows, expandedPriors, priorStudies]
      );

      const rowVirtualizer = useVirtualizer({
        count: displayRows.length,
        getScrollElement: () => tbodyRef.current,
        estimateSize: () => 140,
        overscan: 6,
        // Dynamically measure each row so MobileListComponent's variable
        // height (and any expanded sub-rows) is accounted for.
        measureElement:
          typeof window !== "undefined" &&
          navigator.userAgent.indexOf("Firefox") === -1
            ? (element) => element?.getBoundingClientRect().height
            : undefined,
      });

      const virtualItems = rowVirtualizer.getVirtualItems();
      const totalSize = rowVirtualizer.getTotalSize();

      // Trigger next-page fetch when the last row scrolls into view.
      // Replaces the prior IntersectionObserver sentinel.
      useEffect(() => {
        const lastItem = virtualItems[virtualItems.length - 1];
        if (!lastItem) return;
        if (
          lastItem.index >= displayRows.length - 1 &&
          !dataQuery.isFetching &&
          dataQuery.isFetched
        ) {
          const isCurrentPageFull =
            dataQuery?.data?.rows?.length === pageSize;
          if (
            dataQueryState?.data?.rows?.length > 8 &&
            isCurrentPageFull
          ) {
            setAllowAddingRows(true);
            handleChangeSizeIndex(
              pageIndexFromParent + 1,
              pageSize,
              props.paginationKey || props.id
            );
          }
        }
      }, [
        virtualItems,
        displayRows.length,
        dataQuery.isFetching,
        dataQuery.isFetched,
      ]);

      const spinnerStyle = {
        circle: {
          height: "50px",
          width: "50px",
          borderWidth: "5px",
        }
      }

      // useEffect(()=>{
      //   console.log("--- Status ----",status);
      // },[status]);
    
      const openStudy = (row, dataQueryState) => {
        console.log("--- Row clicked ---",row);
        // NEW: zero-image guard. The mobile/portrait table previously had NO guard at all,
        // so a study with no images opened into an empty viewer here even though the
        // desktop table blocked it.
        if (
          (row.original.noOfImages === 0 ||
            row.original.studyInstanceUId?.includes("DPTK")) &&
          !ZERO_IMAGE_ALLOWED_MODALITIES.includes(row.original?.modality?.name) &&
          !filterInputValues?.infinitViewerUser
        ) {
          console.warn(
            "[studylist][zero-image-guard] study not opened - no images present",
            {
              studyId: row.original.id,
              noOfImages: row.original.noOfImages,
              studyInstanceUId: row.original.studyInstanceUId,
            }
          );
          return;
        }
        // Same priors decision as the desktop table: a study with priors opens on
        // the priors route so the viewer loads them alongside the current study.
        const withPriors =
          row.original.priorsCount > 0 &&
          row.original.showPriors &&
          getEnv("REACT_APP_SHOW_PRIORS") == "true";
        const url =
          (withPriors ? "/new/study/priors/load/" : "/new/study/load/") +
          row.original.id +
          "?firmId=" +
          row.original.assignmentList[0].firmId;

        window.open(url, "_blank")
      };

      let touchStartY = 0;

      const handleTouchEnd = (event) => {
        console.log("--touchStartY--", touchStartY);
        const topRow = document.getElementsByClassName("mobile-top-row")[0]; // Get the first element with class "mobile-top-row"
        if (event?.changedTouches != null && topRow) {
          const touchEndY = event.changedTouches[0].clientY; // Get the final touch position
          const deltaY = touchEndY - touchStartY; // Calculate the vertical distance traveled
      
          // Define the threshold for pull-to-refresh
          const refreshThreshold = 100;
      
          // Check if the top row is visible in the current view
          const topRowRect = topRow.getBoundingClientRect();
          const isTopRowVisible = topRowRect.top >= 0 && topRowRect.bottom <= window.innerHeight;
          console.log("cal->",deltaY," ",refreshThreshold);
          if (deltaY > refreshThreshold && isTopRowVisible) {
            console.log("toprow->",topRow);
            // If the user has pulled down beyond the threshold and the top row is visible, trigger the refresh action
            console.log("Refresh required");
            setShowPullRefreshLoader(true);
            setAllowAddingRows(false);
            handleChangeSizeIndex(0,pageSize,props.paginationKey || props.id);
              setTimeout(() => {
                let filterUpdated = filterApplied + 1;
                setFilterApplied(filterUpdated);
              }, 200);
            
          }
        }
      };

    const handleTouchStart = (event) => {
      touchStartY = event.touches[0].clientY; // Store the initial touch position
    };
    
    const handleScroll = (ev) => {

    }


    return (<>
    <div ref={tbodyRef} className="studylist-mobile-table-container mobile-modal-scroll"
      onScroll={(event) => handleScroll(event)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
        <div
          style={{
            padding: "auto",
            height: "100%",
            width: "100%",
            zIndex: "99999",
            display: `${studyListLoading ? "flex" : "none"}`,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            opacity: "0.4",
            position: "absolute",
            top: "0",
            left: "0",
          }}
        >
          <LoadingBar
            ref={studyListRef}
            color="#0085FF"
            height={5}
            // progress={progress}
            onLoaderFinished={() => setStudyListLoading(false)}
            containerStyle={{
              backgroundColor: "black",
              opacity: "0.8",
              position: "absolute",
              top: "0",
              left: "0",
            }}
            loaderSpeed={1000}
            transitionTime={1000}
          />
        </div>
      
        {showPullRefreshLoader && <div className={`mobile-studylist-top-spinner ${showPullRefreshLoader?"show":""}`}><Spinner size={SpinnerSize.large} styles={spinnerStyle}/></div>}
        {tableRows.length > 0 && (
          <div
            className="studylist-mobile-virtual-list"
            style={{
              height: `${totalSize}px`,
              width: "100%",
              position: "relative",
            }}
          >
            {virtualItems.map((virtualRow) => {
              const row = displayRows[virtualRow.index];
              const isPrior = row.depth > 0;
              const isLastPrior =
                isPrior && displayRows[virtualRow.index + 1]?.parentId !== row.parentId;
              return (
                <div
                  key={row.id}
                  data-index={virtualRow.index}
                  ref={rowVirtualizer.measureElement}
                  className={`study-table-tr studylist-mobile-virtual-row cursor-pointer ${
                    virtualRow.index === 0 ? "mobile-top-row" : ""
                  } ${
                    isPrior
                      ? `studylist-mobile-prior-row ${
                          row.index % 2 === 0
                            ? "tr-alternative-color-prior"
                            : "tr-second-alternative-color-prior"
                        }`
                      : virtualRow.index % 2 === 0
                      ? "tr-alternative-color"
                      : "tr-second-alternative-color"
                  }`}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    transform: `translateY(${virtualRow.start}px)`,
                  }}
                    onClick={() => {
                    if ((props.roles[0] != USERTYPES.FIRMTECHNICIAN || (props.roles[0] == USERTYPES.FIRMTECHNICIAN && (priviledgedFirmTechnician || showViewerTechnician)))
                      && (props.roles[0] != USERTYPES.TYPIST || showViewer))
                      openStudy(row);
                  }}
                >
                  {isPrior && (
                    <div className={isLastPrior ? "studylist-mobile-prior-last-line" : "studylist-mobile-prior-line"} />
                  )}
                  {row.getVisibleCells().map((cell) =>
                    cell.column.columnDef.show ? (
                      <div
                        className="study-mobile-table-td"
                        key={cell.id}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </div>
                    ) : null
                  )}
                </div>
              );
            })}
          </div>
        )}
        {tableRows.length > 0 && dataQuery.isFetching && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <Spinner size={SpinnerSize.large} styles={spinnerStyle} />
          </div>
        )}
        {dataQueryState?.data?.rows?.length == 0 && dataQuery.isFetched && !dataQuery.isFetching && (
          <div className="study-list-spinner study-list-mobile-empty-studies">
            <span className="study-list-no-data-txt">
              {t("study-list.messages.no-result-found")}
            </span>
          </div>
        )}
      </div>
    </>)
}

export default MobileStudyListTable;